import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatDateOrDash } from '#/utils/date';
import { formatDisplayQty } from '#/utils/formatNumber';

import ArrivalScheduleStatusBadge from '#/modules/srmMgmt/purchaseOrder/components/ArrivalScheduleStatusBadge';
import PurchaseOrderArrivalScheduleActionsCell from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderArrivalScheduleActionsCell';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '—';
  }
  const label = [warehouse.code, warehouse.name].filter(Boolean).join(' ');
  return label || '—';
}

export function buildPurchaseOrderArrivalScheduleColumns({
  purchaseOrderId,
  onMutated,
} = {}) {
  return [
    {
      id: 'actions',
      header: '操作',
      minSize: 180,
      size: 200,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <PurchaseOrderArrivalScheduleActionsCell
          purchaseOrderId={purchaseOrderId}
          schedule={row.original}
          onMutated={onMutated}
        />
      ),
    },
    {
      id: 'expectedArrivalDate',
      header: '預計到貨日',
      accessorFn: (row) => formatDateOrDash(row.expectedArrivalDate),
      size: 130,
      enableSorting: false,
    },
    {
      id: 'warehouse',
      header: '倉別',
      accessorFn: (row) => formatWarehouseLabel(row.warehouse),
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 110,
      enableSorting: false,
      cell: ({ row }) => (
        row.original.status
          ? <ArrivalScheduleStatusBadge status={row.original.status} size="sm" />
          : '—'
      ),
      meta: { statusPresentation: 'badge' },
    },
    {
      id: 'plannedQty',
      header: '計劃量',
      accessorFn: (row) => formatDisplayQty(row.plannedQty),
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'receivedQty',
      header: '已收量',
      accessorFn: (row) => formatDisplayQty(row.receivedQty),
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'remainingQty',
      header: '剩餘量',
      accessorFn: (row) => formatDisplayQty(row.remainingQty),
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'td_right' },
    },
    {
      id: 'remark',
      header: '備註',
      accessorFn: (row) => displayDash(row.remark),
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original.remark)} />
      ),
    },
  ];
}
